import { Box, IconButton } from "@material-ui/core";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { FC } from "react";

import CancelingReason from "../../../components/CancelingReason";
import CustomModal from "../../../components/CustomModal";
import TooltipPopover from "../../../components/TooltipPopover";
import useCurrentUser from "../../../hooks/useCurrentUser";
import useIsAdmin from "../../../hooks/useIsAdmin";
import useIsAgent from "../../../hooks/useIsAgent";
import useOnUpdateRecord from "../../../hooks/useOnUpdateRecord";
import colors from "../../../theme/colors";
import { AppResource } from "../../../types/resource.types";
import { adminRef, agentDocRef, requestDocRef } from "../../../utils/referencies";
import { applyUpdateTimestamp } from "../../../utils/timestamp";
import { RequestStatus } from "../types";

const CancelRequest: FC<any> = ({ record: request }) => {
  const status: RequestStatus = request.status;
  const { user } = useCurrentUser();
  const { isAdmin } = useIsAdmin();
  const { isAgent } = useIsAgent();

  const onUpdateRecord = useOnUpdateRecord(
    AppResource.visitsRequests,
    "Request has been canceled",
    "Error on cancel request"
  );

  const getCurrentUserRef = () => {
    return isAdmin ? adminRef(user.id as string) : isAgent ? agentDocRef(user.id as string) : null;
  };

  const handleRejectRecord = async (cancelationReason: string) => {
    await onUpdateRecord(async () => {
      await requestDocRef(request.id).update(
        applyUpdateTimestamp({
          status: RequestStatus.canceled,
          cancelationReason,
          canceledBy: getCurrentUserRef(),
        })
      );
    });
  };

  const ActionIcon = (
    <TooltipPopover message={"Reject request"}>
      <IconButton>
        <HighlightOffIcon style={{ color: colors.error.main }} />
      </IconButton>
    </TooltipPopover>
  );

  return (
    <>
      {status === RequestStatus.pending ? (
        <Box display="flex" alignItems="center">
          <CustomModal ModalOpenButton={ActionIcon}>
            {(modalProps: any) => {
              return (
                <CancelingReason
                  message="Rejection Reason"
                  handleCloseModal={modalProps.handleCloseModal}
                  onRejectRecord={handleRejectRecord}
                  counter={52}
                />
              );
            }}
          </CustomModal>
        </Box>
      ) : null}
    </>
  );
};

export default CancelRequest;
